import LayoutActividad from "../../../components/LayoutActividad";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { modulo13 } from "../../../routes/Module13";
import GuiaDocente from "../../../components/GuiaDocente";
import Sidebar from "../Sidebar";
import { faSignLanguage } from "@fortawesome/free-solid-svg-icons";
import Imagen1 from "../../../images/modulo13/derrame.png";
import AudioPlayer from "../../../audioPlayer/AudioPlayer";
import Audio from "../../../audios/modulo13/Unidad2Actividad8.mp3";

const Actividad9 = () => {
  const infoUnidad = modulo13.content[1];
  const infoAct = modulo13.content[1].activities[10];
  const crumbs = [
    {
      title: modulo13.title,
      url: "/" + modulo13.url,
    },
    {
      title:
        modulo13.content.length === 1
          ? `${infoAct.name}`
          : `${infoUnidad.name} > ${infoAct.name}`,
      url: infoAct.path,
    },
  ];

  const pages = {
    titlePrev: `${modulo13.content[1].name}: ${modulo13.content[1].activities[9].name}`,
    linkPrev: `${modulo13.url}/${modulo13.content[1].path}/${modulo13.content[1].activities[9].path}`,
    titleNext: `${modulo13.content[1].name}: ${modulo13.content[1].activities[11].name}`,
    linkNext: `${modulo13.url}/${modulo13.content[1].path}/${modulo13.content[1].activities[11].path}`,
  };
  const metadata = {
    color: modulo13.color,
    title: `${modulo13.title} - ${infoAct.name}`,
    name: modulo13.title,
  };

  return (
    <LayoutActividad
      pages={pages}
      crumbs={crumbs}
      sidebar={<Sidebar />}
      modulo={metadata}
    >
      <p>
        <small className={`c-${modulo13.color} hat-text`}>
          <FontAwesomeIcon icon={faSignLanguage} /> Hacemos
        </small>
      </p>

      <h2 className="mb-5">{infoAct.name}</h2>
          <AudioPlayer track={Audio} />
      <ul className="mb-0">
        <li>Observa la siguiente ilustración:</li>
      </ul>

      <img src={Imagen1} className="img-fluid" alt="Peruanos" />

      <div className="row">
        <div className="col-lg-10 col-12">
          <ul>
            <li>
              Conversa acerca de lo siguiente con un compañero, compañera o
              familiar y escriban sus respuestas:
            </li>
          </ul>

          <p>¿Qué problema se observa en la imagen?</p>
          <textarea className="form-control mb-4" rows={3} />

          <p>Según la imagen, ¿cuáles podrían ser las causas del problema?</p>
          <textarea className="form-control mb-4" rows={3} />

          <p>¿Qué consecuencias se observan?</p>
          <textarea className="form-control" rows={3} />
        </div>
      </div>

      <GuiaDocente>
        <ul>
          <li>
            Explique que el objetivo de estas actividades es que tomen
            conciencia de la importancia de estar informados y de involucrarse
            en acciones que contribuyan a la protección de nuestros recursos
            naturales.
          </li>
          <li>
            Lea la primera indicación: Observa la siguiente ilustración. Pida
            que se detengan en los detalles que ofrece la ilustración. Lea la
            segunda indicación: Conversa acerca de lo siguientes con un
            compañero o compañera y escriban sus respuestas: ¿Qué problema se
            observa en la imagen? ¿Cuáles podrían ser las causas del problema
            según la imagen? ¿Qué consecuencias se observan?
          </li>
          <li>
            Pregunte si han comprendido las preguntas. Es momento de explicar la
            diferencia entre las causas y las consecuencias de un problema.
            Puede, por ejemplo, señalar lo siguiente:
            <ul>
              <li>
                <i>
                  “Las causas explican el origen, el motivo por el que se dan
                  determinados fenómenos, hechos o situaciones. Por ejemplo,
                  ¿cuál es la causa de que tenga sed? Es que jugué un partido de
                  vóley bajo el sol. Entonces, se puede determinar que la sed
                  fue originada por la actividad física y el calor. En cambio,
                  las consecuencias son resultado de los fenómenos, hechos o
                  situaciones. Por ejemplo, ¿cuál es la consecuencia de haber
                  hecho deporte bajo el sol? Me dio mucha sed”.
                </i>
              </li>
            </ul>
          </li>

          <li>
            Dé un tiempo para que trabajen. Pídales que respondan las preguntas
            de manera oral y lleguen a un acuerdo. Retome las respuestas y
            lleguen a un consenso sobre qué escribir. Por ejemplo:
            <ul>
              <li>
                <i>
                  “¿Qué problema se observa en la imagen? (Posible respuesta: Se
                  observa el derrame de petróleo en un río).
                </i>
              </li>
              <li>
                <i>
                  ¿Cuáles podrían ser las causas del problema según la imagen?
                  (Posible respuesta: Se podría deber a la rotura de un
                  oleoducto).
                </i>
              </li>
              <li>
                <i>
                  ¿Qué consecuencias se observan? (Posible respuesta: Se observa
                  a los animales del río con problemas: aves cubiertas de
                  petróleo y peces muertos. Es probable que los vecinos de la
                  zona vean afectado su consumo de agua).
                </i>
              </li>
            </ul>
          </li>
        </ul>
      </GuiaDocente>
    </LayoutActividad>
  );
};

export default Actividad9;
